import { broadcastSignOut } from "./signOutBroadcast";

const signOut = async (advisor = false, bankTransfer = false) => {
  broadcastSignOut();
  window.location.href = `/api/auth/logout?advisor=${advisor}&bankTransfer=${bankTransfer}`;
};

export default signOut;
